/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import {
  requestRecoveryForm,
  sendForm
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import { selectRecoveryRequestState } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TaskFrom from './../../../../../components/Tasks/TaskFrom';
import LargePreLoader from '../../../../../components/Common/PreLoaders/LargePreLoader';

class TaskCopy extends Component {
  constructor(props) {
    super(props);
    props.requestRecoveryForm();
  }

  render() {
    const hasNewTask = true;
    return (
      <React.Fragment>
        {this.props.recoveryRequestState.hasInProgress ? (
          <LargePreLoader />
        ) : (
          <TaskFrom
            reducerName={this.props.reducerName}
            sendForm={() => this.props.sendForm()}
            hasNewTask={hasNewTask}
          />
        )}
      </React.Fragment>
    );
  }
}

TaskCopy.propTypes = {
  reducerName: PropTypes.string.isRequired,
  taskId: PropTypes.string.isRequired,

  // CONNECT
  recoveryRequestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired
  }).isRequired,
  requestRecoveryForm: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({
  recoveryRequestState: selectRecoveryRequestState(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  requestRecoveryForm: () =>
    dispatch(requestRecoveryForm(props.reducerName, { id: props.taskId })),
  sendForm: () => dispatch(sendForm(props.reducerName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaskCopy);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/TaskCopy/TaskCopy.js